import './Categories.scss'
import { useEffect, useState } from "react";
import { get_categories, get_channels } from "../../../../../server/requests";
import icon_back from "../../../../SubUsers/images/back-button.png";
import MiniCardChannel from "../MiniCardChannel";
import { useRouter } from "../../../../../hooks/router";


export default function ({ btn_fields_live, stop_propogation_live, favourites }) {
    const router = useRouter()

    const [allChannels, setAllChannels] = useState([])
    const [categories, setCategories] = useState([])
    const [channels, setChannels] = useState({})
    const [showLoading, setShowLoading] = useState(false)
    const [activeKey, setActiveKey] = useState('All')

    useEffect(() => {
        setShowLoading(true)
        get_channels({}, data => {
            setAllChannels([...data])
        }, err => console.log(err, 'error'))
        get_categories({}, data => {
            setCategories([...data])
        }, err => console.log(err, 'error'))
    }, [])

    useEffect(() => {
        if (categories.length && allChannels.length) {
            sort_channels()
        }
    }, [allChannels, categories])

    const sort_channels = () => {
        let _categories = {};
        let categories_ = [...categories]
        let all = {
            name: 'All',
            archive: false,
            content: [],
            image: '',
            id: 124125124,
            color: "#0693e3"
        }
        let fav = {
            name: 'Favorites',
            archive: false,
            content: [],
            image: '',
            id: 102123123,
            color: "#0693e3"
        }
        categories_.unshift(fav)
        categories_.unshift(all)
        for (let i = 0; i < categories_.length; i++) {

            categories_[i].content = [];

            let id = categories_[i].id;
            let _key = categories_.find(e => e.id == id)

            _categories[_key.name] = categories_[i];

        }


        for (let j = 0; j < allChannels.length; j++) {
            _categories['All'].content.push(allChannels[j])

            for (let k = 0; k < allChannels[j].categories.length; k++) {

                let c_id = allChannels[j].categories[k];

                let _key = categories_.find(e => e.id == c_id)
                if (_key && _key.name && _categories[_key.name]) _categories[_key.name].content.push(allChannels[j])
            }
        }

        if (favourites.array && favourites.array.length) _categories['Favorites'].content = [...favourites.array]

        setChannels({ ..._categories })
        setShowLoading(false)
    }

    const btn_get_channels_by_categories = (key) => {
        setActiveKey(key)
    }
    const btn_channel_categories = (e) => {
        router.push(`/player?type=live&id=${e.id}`)
    }

    return (
        <div className="live_player_fields" onClick={btn_fields_live}>
            <div className="btn_back_categories">
                <img src={icon_back} alt="" onClick={btn_fields_live} />
            </div>
            <div className="main_categories_field" onClick={stop_propogation_live}>
                <div className="categories">
                    <h1 className="title_categories">Categories</h1>
                    <div className="parent_channels">
                        {Object.keys(channels).map((e, i) => {
                            return channels[e].content.length ? (
                                <div className="card_categories"
                                    style={activeKey == e ? { borderColor: 'white' } : null} key={i}
                                    onClick={() => btn_get_channels_by_categories(e)}>
                                    <span>{e}</span>
                                </div>
                            ) : null
                        })}
                    </div>
                </div>
                <div className="categories">
                    <h1 className="title_categories">Channels</h1>
                    <div className="parent_channels">
                        {Object.keys(channels).map(key => {
                            return activeKey == key ?
                                channels[key].content.map((e, i) => {
                                    return <MiniCardChannel
                                        activeChannel={''}
                                        class_name="large"
                                        key={i}
                                        btn_channel_live_fields={btn_channel_categories}
                                        elem={e} index={i} />
                                })
                                : null
                        })}
                    </div>

                </div>
            </div>
        </div>
    )
}